import { render, staticRenderFns } from "./EcommerceBrowserStates.vue?vue&type=template&id=354bb959"
import script from "./EcommerceBrowserStates.vue?vue&type=script&lang=js"
export * from "./EcommerceBrowserStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports